/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';

// TODO: Option ordering
const hiddenFieldNames = [
  'bulkCommunicationID',
];

export const BulkCommunicationPreviewOverride = fr.metaOverride()
    .override({ readonly: true }, { hidden: true })
    .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true })
    .done();
